import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { joyrideService } from "../joyrideService";
import TutorialSkipConfirmationContent from "../components/TutorialSkipConfirmationContent";

interface OnlineBookingSkipTutorialConfirmationProps {
    onContinueTutorial: () => void;
    onAfterSkipTutorial?: () => void;
}

const OnlineBookingSkipTutorialConfirmation: React.FC<OnlineBookingSkipTutorialConfirmationProps> = ({
    onContinueTutorial,
    onAfterSkipTutorial,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { branchId } = useParams();

    const handleSkipTutorial = () => {
        localStorage.setItem("run", "false");
        localStorage.removeItem("step");
        joyrideService.clearUser();
        navigate(`/logbook/journal/${branchId}`);
        onAfterSkipTutorial?.();
    };

    return (
        <TutorialSkipConfirmationContent
            title={t("Want to learn on your own?")}
            description={t("Save your time by taking a quick online training course")}
            additionalDescription={
                <Trans
                    i18nKey="You can take the training later by clicking the button <strong>How to connect Online Booking?</strong> in the menu."
                    components={{ strong: <strong /> }}
                />
            }
            onContinueTutorial={onContinueTutorial}
            onSkipTutorial={handleSkipTutorial}
        />
    );
};

export default OnlineBookingSkipTutorialConfirmation;
